var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720.67-120H276v-514.67L554.67-920l38.66 34q9.67 7.67 13.5 18.33 3.83 10.67 3.83 23v11.34L566-634.67h287.33q26 0 46.34 20.34Q920-594 920-568v81.33q0 9.67-2.17 22-2.16 12.34-6.5 22L794-170q-9 20.67-29.67 35.33Q743.67-120 720.67-120ZM209.33-634.67V-120H80v-514.67h129.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.74807a3bc3e6631ed528deebe139cbf0.svg";
export { ForwardRef as ReactComponent };